import React from 'react';
import { ChangeDishPositionState } from './changeDishPositionState/ChangeDishPositionState';
import { ChangeDishPosition } from './components/ChangeDishPosition/ChangeDishPosition';

export const ChangeDishPositionPageV2: React.FC = () => {
	return (
		<ChangeDishPositionState>
			<ChangeDishPosition />
		</ChangeDishPositionState>
	);
};
